// OButton
export const ButtonSizes = Object.freeze({
  medium: 'md',
  small: 'sm'
} as const)

export type ButtonSize = (typeof ButtonSizes)[keyof typeof ButtonSizes]

export const ButtonTypes = Object.freeze({
  solid: 'solid',
  border: 'border',
  link: 'link'
} as const)

export type ButtonType = (typeof ButtonTypes)[keyof typeof ButtonTypes]

export const ButtonVariants = Object.freeze({
  primary: 'primary',
  secondary: 'secondary',
  success: 'success',
  info: 'info',
  danger: 'danger',
  dark: 'dark',
  gray: 'gray',
  ghost: 'ghost',
  white: 'white',
  gold: 'gold',
  green: 'green',
  darkGreen: 'dark-green',
  faded: 'faded',
  fadedBlack: 'faded-black',
  error: 'error'
} as const)

export type ButtonVariant = (typeof ButtonVariants)[keyof typeof ButtonVariants]

// OToaster
export const ToasterVariants = Object.freeze({
  success: 'success',
  info: 'info',
  warning: 'warning',
  danger: 'danger'
} as const)

export type ToasterVariant = (typeof ToasterVariants)[keyof typeof ToasterVariants]

// OMessage
export const MessageVariants = Object.freeze({
  danger: 'danger'
} as const)

export type MessageVariant = (typeof MessageVariants)[keyof typeof MessageVariants]

// OStatusModal
export const StatusModalVariants = Object.freeze({
  danger: 'danger'
} as const)

export type StatusModalVariant = (typeof StatusModalVariants)[keyof typeof StatusModalVariants]

// OIconCircle
export const IconCircleBackgrounds = Object.freeze({
  default: 'default',
  danger: 'danger',
  success: 'success',
  warning: 'warning'
} as const)

export type IconCircleBackground = (typeof IconCircleBackgrounds)[keyof typeof IconCircleBackgrounds]
